import { Directive, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';

// shows [appFitText], or [fitTextShort] instead when the full text doesn't fit the element's width (as 1.5M for
// 1,529,898). The element should keep to one line and hide what overflows, so its width doesn't follow its text
@Directive({ selector: '[appFitText]', standalone: true })
export class FitTextDirective implements OnChanges, OnDestroy {
    @Input('appFitText') text = ''
    @Input() fitTextShort?:string

    private observer:ResizeObserver|undefined

    constructor(private el:ElementRef<HTMLElement>) {
        if (typeof ResizeObserver !== 'undefined') {
            this.observer = new ResizeObserver(() => this.fit())
            this.observer.observe(this.el.nativeElement)
        }
    }

    ngOnChanges() {
        this.fit()
    }

    ngOnDestroy() {
        this.observer?.disconnect()
    }

    private fit() {
        const el = this.el.nativeElement
        el.textContent = this.text
        if (this.fitTextShort && this.fitTextShort !== this.text && el.scrollWidth > el.clientWidth) el.textContent = this.fitTextShort
    }
}
